import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import MainLayout from '../layouts/MainLayout.vue';
import AuthLayout from '../layouts/AuthLayout.vue';
import Home from '../pages/Home.vue';
import Login from '../pages/Login.vue';
import Dashboard from '../pages/Dashboard.vue';
import ErrorNotFound from '../pages/ErrorNotFound.vue';
import BillingManagement from '../components/BillingManagement.vue';

// Define routes
const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        meta: { requiresAuth: false },
      },
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: { requiresAuth: false },
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { requiresAuth: true },
      },
      {
        path: 'billing-management',
        name: 'billing-management',
        component: BillingManagement,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [],
  },
  {
    path: '/:catchAll(.*)*',
    name: 'error-not-found',
    component: ErrorNotFound,
    meta: { requiresAuth: false },
  },
];

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard for Authentication
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'login' });
  }

  next();
});

export default router;
